module.exports = __webpack_public_path__ + "static/media/google.f20fc915.png";